import * as angular from 'angular';
import * as _ from 'lodash';

import { ComponentDefinition, Dashboard, EventEmailDefinition } from '../../models';
import { IPrintOptionsService, IStoreService } from '../../services';
import { StoreElement } from '../../stateManagement';
import { PageOption } from '../../services/helpers/print';
import { isInRecipients } from '../../models/mailing/RecipientList';
import { MixedUserChoice } from '../../models/mailing/MixedUserChoice';

//TODO there has to be a way to merge this with other email composer...

class HtmlEmailComposerController implements angular.IComponentController {
    toolbar: string[][];
    email: EventEmailDefinition;
    options: PageOption[];
    isLoading: boolean;
    load: () => void;
    dashboards: Dashboard[];
    recipientChoices: MixedUserChoice[];

    private _unsubscribe: () => void;
    static $inject = [
        'storeService',
        'printOptionsService',
        'dashboardActionsService'
    ];

    constructor(
        private _storeService: IStoreService,
        private _printOptionsService: IPrintOptionsService,
    ) { }

    $onInit() {
        this.toolbar = [
            ['h1', 'h2', 'h3', 'h4', 'p', 'pre', 'quote'],
            ['bold', 'italics', 'underline', 'strikeThrough', 'ul', 'ol', 'redo', 'undo', 'clear'],
            ['justifyLeft', 'justifyCenter', 'justifyRight', 'indent', 'outdent'],
            ['html', 'insertLink',]
        ];

        this.options = [{ name: '', configuration: null }]
            .concat(this._printOptionsService.getOptions());
        this.isLoading = true;
        this._unsubscribe = this._storeService.register(store => {
            this.dashboards = _.values(store.dashboards.dictionary).sort((a, b) => a.name > b.name ? 1 : -1);
            this.isLoading = false;
        }, [
            StoreElement.Dashboards
        ]);
        this.rebuildChoices();
    }

    $onDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    }

    $onChanges(changesObj: angular.IOnChangesObject) {
        if (changesObj['email'] || changesObj['recipientChoices']) {
            this.rebuildChoices();
        }
    }

    private rebuildChoices() {
        if (this.email && this.email.recipients
            && this.recipientChoices && this.recipientChoices.length > 0) {
            const rebuilded = this.recipientChoices.filter(rc => isInRecipients(this.email.recipients, rc));
            this.email.selectedChoices = rebuilded;
        }
    }
}

export const wtHtmlEmailComposer: ComponentDefinition = {
    componentId: 'wtHtmlEmailComposer',
    controller: HtmlEmailComposerController,
    template: require('./htmlEmailComposer.component.html'),
    controllerAs: 'vm',
    bindings: {
        email: '<',
        formController: '=?',
        isLoading: '<?',
        recipientChoices: '<'
    }
};